export default {"src":"/uk/_next/static/media/documentResourcesIcon.13fa19a2.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};